<script>
  import { Preview } from '@client/pages/bizcards/components';

  import { createBizcardPreviewStore } from '@client/stores/bizcard-preview';

  export let rulename;

  const { renderedTemplate, loading } = createBizcardPreviewStore(rulename);
</script>

<Preview bezel html={$renderedTemplate} loading={$loading} title={rulename} width={120} height={240} scale={0.32} />

<small class="d-block mt-1">{rulename}</small>
